import { Button } from "@mui/material";
import { useState } from "react";
import { OrderSupplier, OrderSupplierCsv } from "../types";
import { toOrderSupplierCheck } from "../utils/common";
import OrderSupplierConfirmTable from "./OrderSupplierConfirmTable";

type Props = {
  open: boolean;
  onClose: Function;
  onUpdate: Function;
  selectedOrderList: OrderSupplier[];
  isUpdateProcessing: boolean;
};

/**
 * 出荷確認モーダル
 * @param root0 コンポーネントのプロップス
 * @returns JSX.Element
 */
export default function OrderSupplierConfirmDialog({
  open,
  onClose,
  onUpdate,
  selectedOrderList,
  isUpdateProcessing,
}: Props) {
  const [editedOrderList, setEditedOrderList] = useState<OrderSupplierCsv[]>([]);
  const ActionButtons = (
    <>
      <Button variant="custom-outlined" onClick={() => onClose()}>
        キャンセル
      </Button>
      <Button variant="contained" onClick={() => onUpdate(editedOrderList)} disabled={isUpdateProcessing}>
        出荷
      </Button>
    </>
  );
  return (
    <OrderSupplierConfirmTable
      open={open}
      onClose={onClose}
      orderList={toOrderSupplierCheck(selectedOrderList)}
      editedOrderList={editedOrderList}
      setEditedOrderList={setEditedOrderList}
      ActionButtons={ActionButtons}
      title="出荷確認"
      content="以下の注文を出荷します。よろしいですか？"
      editable
    />
  );
}
